import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DonutChartData } from '../../../../shared/components/donut-chart/donut-chart-data';

@Component({
  selector: 'app-fund-allocation-visualization',
  templateUrl: './fund-allocation-visualization.component.html',
  styleUrls: ['./fund-allocation-visualization.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FundAllocationVisualizationComponent {
  @Input() donutChartData: DonutChartData[] = [];
  @Input() backgroundColor: string = '#FFFFFF';
  @Input() borderColor: string = '#E5E7EB';
  @Input() label: string = '';
}
